import { GraphQLClient } from 'graphql-request'
import settings from './settings'
import { getAccessToken } from './httpService'

const _CLIENT = new GraphQLClient(`${settings.kreaBaseUrl}/graphql`)

const modifyRequestPromise = (promise) => {
	return promise.catch(async (err) => {
		if (err.response.errors[0].message === 'UNAUTHENTICATED') {
			return true
		} else {
			return true
		}
	})
}

/*
    Implement global error handling for graphql-request client using ES6 Proxy
    Here we modify ONLY `client.request` to add global error handling, via .catch
*/
export const client = new Proxy(_CLIENT, {
	get: function (target, propKey, receiver) {
		var propValue = target[propKey]
		// Proxy property access on `client` with no interference
		if (typeof propValue != 'function') {
			return propValue
		} else {
			return async function () {
				if (propKey === 'request') {
					// This acts as an interceptor for the requests.
					// It will set auth token in header, auto refresh tokens and redirect to login if needed.
					let currentAccessToken = await getAccessToken()
					target.setHeader('authorization', `Bearer ${currentAccessToken}`)
					// Modify `client.request`, see `modifyRequestPromise`
					return modifyRequestPromise(propValue.apply(this, arguments))
				} else {
					// Proxy function calls that are not `client.request` with no interference
					return propValue.apply(this, arguments)
				}
			}
		}
	}
})
